<template>
  <div class="restaurant-container">
    <restaurant-info-modal/>
    <div class="restaurant-background-image">
      <div
        data-aos="fade-up"
        data-aos-offset="200"
        data-aos-delay="50"
        data-aos-duration="1000"
        data-aos-easing="ease-in-out"
        class="restaurant-header-title-container"
      >
        <h4>Våre</h4>
        <h2 class="restaurant-header-title">Restauranter</h2>
        <img class="restaurant-title-logo" :src="menu" />
      </div>
    </div>
    <div class="restaurant-list-container">
      <header class="restaurant-list-header">Velg avdeling</header>

      <loading-card v-show="isLoading" />
      <restaurants-list
        v-show="!isLoading"
        :restaurants="restaurants"
        @restaurantSelected="handleRestaurantSelected"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { CHANGED_RESTAURANT_EVENT, EXCEPTION_EVENT } from "../../events/eventsSource";

import RestaurantsList from "../../components/lists/RestaurantsList";
import RestaurantCard from "../../components/cards/RestaurantCard";
import LoadingCard from "../../components/spinnings/LoadingCard.vue";
import RestaurantInfoModal from '../../components/modals/RestaurantInfoModal.vue';
export default {
  inject: ["eventBus"],
  components: {
    RestaurantsList,
    RestaurantCard,
    LoadingCard,
    RestaurantInfoModal
  },
  computed: {
    ...mapState({
      restaurants: state => state.restaurants.restaurants
    })
  },
  data() {
    return {
      menu: require("@/assets/images/calli-great.png"),
      isLoading: true
    };
  },
  methods: {
    handleRestaurantSelected(e) {
      //console.log(e);
      this.eventBus.$emit(CHANGED_RESTAURANT_EVENT, e);
      this.$store.commit("restaurants/SET_CURRENT_RESTAURANT_STATE", e);
      this.$store.commit("cart/CLEAR_CART_STATE", e);
      this.$store.commit("payment/CLEAR_PAYMENT_SESSION_STATE", e);
      this.$router.push("/menu");
    }
  },
  async created() {
    let error = await this.$store.dispatch("restaurants/getRestaurantsAction");

    //
    //emit events to redirect
    //
    if (error != null) {
      console.log('error from restaurant views')
      this.eventBus.$emit(EXCEPTION_EVENT, error);
    }

    this.isLoading = false; 
  }
};
</script>

<style lang="scss">
$desktop: 1200px;
$laptop: 1024px;
$tablet: 768px;
$mobile: 480px;

.ant-spin-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.restaurant-list-header {
  margin: 4% 25% 4% 25%;
  text-align: center;
  font-family: Bebas;
  font-size: 36px;
}

.restaurant-background-image {
  background-image: url("~@/assets/images/cartview-image.jpg");
  background-size: cover;
  height: 490px;
  width: 100%;
  object-fit: cover;
  display: grid;
  place-items: center;
  @media (max-width: $mobile) {
    height: 200px;
    position: static;
    bottom: 0;
  }
}

.restaurant-header-title-container {
  background-color: white;

  height: 200px;
  width: 18%;
  border-radius: 50px;
  display: grid;
  place-items: center;

  @media (max-width: $mobile) {
    height: 100px;
    width: 50%;
    border-radius: 30px;
  }

  @media (min-width: $mobile) {
    height: 200px;
    width: 310px;
    border-radius: 30px;
  }
}

.restaurant-title-logo {
  position: relative;
  bottom: 20px;
  width: 80px;
  @media (max-width: $mobile) {
    height: 60px;
    width: auto;
  }
}
.restaurant-header-title {
  text-align: center;
  text-transform: uppercase;
  font-family: Bebas;
  font-weight: 400;
  margin: 0;
  font-size: 2vw;
  @media (max-width: $mobile) {
    font-size: 2em;
    position: relative;
    bottom: 10px;
  }
  @media (min-width: $mobile) {
    font-size: 40px;
  }
}

h4 {
  text-align: center;
  font-family: Roboto, sans-serif;
  font-weight: 400;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 2px;
  color: #878787;
  position: relative;
  top: 25px;
  @media (max-width: $mobile) {
    font-size: 1em;
    top: 10px;
  }
  @media (min-width: $mobile) {
    font-size: 17px;
  }
}
</style>
